/* unplugin-vue-components disabled */import { render } from "./ExamQuizQuestionsResults.vue?vue&type=template&id=3bdb7363&ts=true"
import script from "./ExamQuizQuestionsResults.vue?vue&type=script&lang=ts"
export * from "./ExamQuizQuestionsResults.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__